export default "__VITE_ASSET__N3QQHXfk__"